import config from '../../../../config'

export const MENU_ITEM_KEYS = {
    GENERAL: 'general',
    EDIT_PROFILE: 'editProfile',
    CHANGE_PASSWORD: 'changePassword',
    HISTORY_MAIN: 'historyMain',
    HISTORY_REPORT: 'historyReport',
    HISTORY_DISTRAINT: 'historyDistraint',
    HISTORY_PORTFOLIO: 'historyPortfolio',
    IMPORTER: 'importer',
}

export const MENU_CONFIGURATION = [
    {
        key: MENU_ITEM_KEYS.GENERAL,
    },
    {
        key: MENU_ITEM_KEYS.EDIT_PROFILE,
    },
    {
        key: MENU_ITEM_KEYS.CHANGE_PASSWORD,
    },
    {
        key: MENU_ITEM_KEYS.HISTORY_MAIN,
        restrictionTo: [
            config.modules.report.key,
            config.modules.linkages.key,
            config.modules.distraints.key,
            config.modules.portfolio.key,
        ],
        subMenu: [
            {
                key: MENU_ITEM_KEYS.HISTORY_REPORT,
                restrictionTo: [config.modules.report.key, config.modules.linkages.key],
            },
            {
                key: MENU_ITEM_KEYS.HISTORY_DISTRAINT,
                restrictionTo: [config.modules.distraints.key],
            },
            {
                key: MENU_ITEM_KEYS.HISTORY_PORTFOLIO,
                restrictionTo: [config.modules.portfolio.key],
            },
        ],
    },
    {
        key: MENU_ITEM_KEYS.IMPORTER,
        restrictionTo: ['importer'],
    },
]

export const MENU_DEFAULT_PATH = [MENU_ITEM_KEYS.GENERAL]

export const LOCALE_PREFIX = 'components.Dialog.components.UserProfile'
